import { Component, OnInit, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { map, filter, switchMap } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
  userNameFormControl = new FormControl('', [
    Validators.required
  ]);
  emailFormControl = new FormControl('', [
    Validators.required
  ]);
  passwordFormControl = new FormControl('', [
    Validators.required
  ]);
  mobileFormControl = new FormControl('', [
    Validators.required
  ]);
  confirmPasswordFormControl = new FormControl('', [
    Validators.required
  ]);
  files: File[] = [];
  isRegistering = false;
  // 'info', 'success', 'warning', 'danger'
  alertType = '';
  alertMsg = '';
  showAlert = false;
  isCollapsed = true;
  authSub;
  uploadPercent;
  constructor(public afAuth: AngularFireAuth, private storage: AngularFireStorage) { }

  ngOnInit() {
    this.afAuth.authState.subscribe((user)=>{
      if (user) {
        this.userNameFormControl.setValue(user.displayName);
        this.emailFormControl.setValue(user.email);
        this.mobileFormControl.setValue(user.phoneNumber);

      }
    })
  }

  ngOnDestroy() {
    if (this.authSub) {
      this.authSub.unsubscribe();
    }
  }

  signout() {
    this.afAuth.signOut();
  }

  updateProfile() {
    this.afAuth.authState.subscribe((user)=>{
      user
      .updateProfile({
        displayName: this.userNameFormControl.value,
        photoURL: "",
      })
      .then(
        (response) => {
          this.showAlert = true;
          this.alertType = 'success';
          this.alertMsg = 'Great! Profile updated successfully.';
        },
        (error) => {}
      );
    });
  }

  /**
   *
   * Add dropped or selected files to the array to be uploaded
   * @param event
   */
  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  /**
   * Remove files previously queued for upload
   * @param event
   */
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  async uploadFiles() {
    //Assign files to a local array
    //Remove all files from the global queue
    //Upload the files to Firebase
    //Get the download url
    //Update notes. Push to the image array
    //Clear local array
    let tempFiles = this.files;
    let currentUser = await this.checkAuthenticationStatus();
    

    tempFiles.forEach((fileItem, index) => {
      let filePath;
      let nodeType;
      let noteItem = {};
      let itemIndex: number;
      
      filePath =
        "/Users/" +
        (<any>currentUser).uid +
        "/profile";
      
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, fileItem);

      // observe percentage changes
      this.uploadPercent = task.percentageChanges();
      // get notified when the download URL is available
      task.then(() => {
        fileRef.getDownloadURL().subscribe((url) => {
          (<any>currentUser).updateProfile({
            displayName: this.userNameFormControl.value,
            photoURL: url,
          })
          .then(
            (response) => {console.log('Profile updated successfully.')},
            (error) => {}
          );

        });
      });
    });

    this.files = [];
    tempFiles = [];
  }

   /**
   * Get the user id if authenticated user is found
   */
  checkAuthenticationStatus() {
    return new Promise((resolve, reject) => {
      this.authSub = this.afAuth.user.subscribe((user) => {
        if (user) {
          resolve(user);
        } else {
          reject(false);
        }
      });
    });
  }

  onAlertClosed(alert) {
    this.showAlert = false;
  }

}
